import { TYPES } from "./order_bailiff.type";
import { getDocs, onSnapshot, query, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";
import { getApiFunctions } from "store/bailiff/api";
import { getApp } from "firebase/app";

const app = getApp();
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider
const allOrderBailiffSub = [];
export const snapOrderBailiffById =
  ({ jobId }, callback) =>
  (dispatch) => {
    setOrderBailiffAllSuccess(dispatch, null);
    const uid = auth?.currentUser?.uid;
    const cRef = getRefs().order;
    const c0 = where("job", "==", jobId);
    const c1 = where("client", "==", uid);
    const c2 = where("status", "==", "waiting");
    const qRef = query(cRef, c0, c1, c2);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc.data());
        const detail = data?.length > 0 ? data[0] : null;
        setOrderBailiffAllSuccess(dispatch, detail);
        if (callback) {
          callback();
        }
      }
    });
    allOrderBailiffSub.push(unsub);
  };

export const unSnapOrderBailiff = () => (dispatch) => {
  allOrderBailiffSub.forEach((subscriber) => {
    subscriber();
  });
  allOrderBailiffSub.length = 0;
};
// ========= cloud function =========//

// ========= complex qr generation ===========//
// const STATUS = ["waiting for deposit", "waiting for payoff"];
export const getJobBailiffAndGenerateQR =
  ({ jobId, type = "deposit" }, callback) =>
  async (dispatch) => {
    setOrderBailiffAllSuccess(dispatch, null);
    setOrderBailiffQRSuccess(dispatch, null);
    // setOrderBailiffOpenPaymentSuccess(dispatch, false);
    const uid = auth?.currentUser?.uid;
    const cRef = getRefs().order;
    console.log({ jobId, uid, type });

    const c0 = where("job", "==", jobId);
    const c1 = where("client", "==", uid);
    const c2 = where("type", "==", type);
    const qRef = query(cRef, c0, c1, c2);
    const snapshot = await getDocs(qRef);
    if (!snapshot) {
      callback && callback({ status: 500, data: "Không tìm thấy dữ liệu" });
    }

    const data = snapshot?.docs?.map((doc) => doc?.data());
    const detail = data?.length > 0 ? data[0] : null;
    console.log({ data, detail });
    setOrderBailiffAllSuccess(dispatch, detail);
    if (!detail) {
      callback && callback({ status: 500, data: "Không tìm thấy dữ liệu" });
    }

    // lấy order-id.
    const id = detail?.id;
    const functions = getApiFunctions().client.clientOrderBailiffQRGenerate;
    const options = { id };
    functions(options)
      .then((res) => {
        const data = res?.data;
        setOrderBailiffQRSuccess(dispatch, data);
        // setOrderBailiffOpenPaymentSuccess(dispatch, true);
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

// ========= local function =========//
export const setOrderBailiffAll = (data, callback) => (dispatch) => {
  setOrderBailiffAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setOrderBailiffOpenAdd = (data, callback) => (dispatch) => {
  setOrderBailiffOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setOrderBailiffOpenEdit = (data, callback) => (dispatch) => {
  setOrderBailiffOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setOrderBailiffOpenPayment = (data, callback) => (dispatch) => {
  setOrderBailiffOpenPaymentSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setOrderBailiffSelected = (data, callback) => (dispatch) => {
  setOrderBailiffSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setOrderBailiffSearch = (data, callback) => (dispatch) => {
  setOrderBailiffSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setOrderBailiffQR = (data, callback) => (dispatch) => {
  setOrderBailiffQRSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setOrderBailiffAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ORDER_BAILIFF_ALL,
    payload: data,
  });
};

const setOrderBailiffOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ORDER_BAILIFF_OPEN_ADD,
    payload: data,
  });
};

const setOrderBailiffOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ORDER_BAILIFF_OPEN_EDIT,
    payload: data,
  });
};

const setOrderBailiffSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ORDER_BAILIFF_SELECTED,
    payload: data,
  });
};

const setOrderBailiffSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ORDER_BAILIFF_SEARCH,
    payload: data,
  });
};

const setOrderBailiffQRSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ORDER_BAILIFF_QR,
    payload: data,
  });
};

const setOrderBailiffOpenPaymentSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ORDER_BAILIFF_OPEN_PAYMENT,
    payload: data,
  });
};
